var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulkmailLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.45 41.25Q5.5 41.25 4.125 39.875Q2.75 38.5 2.75 36.55V11.45Q2.75 9.5 4.125 8.1Q5.5 6.7 7.45 6.7H40.55Q42.5 6.7 43.9 8.1Q45.3 9.5 45.3 11.45V36.55Q45.3 38.5 43.9 39.875Q42.5 41.25 40.55 41.25ZM24 26.5 7.45 15.35V36.55Q7.45 36.55 7.45 36.55Q7.45 36.55 7.45 36.55H40.55Q40.55 36.55 40.55 36.55Q40.55 36.55 40.55 36.55V15.35ZM24 22.35 40.35 11.45H7.7ZM7.45 15.35V11.45V15.35V36.55Q7.45 36.55 7.45 36.55Q7.45 36.55 7.45 36.55Q7.45 36.55 7.45 36.55Q7.45 36.55 7.45 36.55Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkmailLogo);
export default __webpack_public_path__ + "static/media/bulkmailLogo.e82af963a832190051b27a4c3d2c637c.svg";
export { ForwardRef as ReactComponent };